<template lang='pug'>
  i.svg-icon.svg-icon-user
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M82.189,91.451c-2.339,0-4.235-1.896-4.235-4.234v-7.945c0-6.424-5.224-11.649-11.646-11.649H34.541 c-6.421,0-11.645,5.226-11.645,11.649v7.938c0,2.339-1.896,4.235-4.235,4.235s-4.235-1.896-4.235-4.235v-7.938 c0-11.094,9.024-20.12,20.116-20.12h31.765c11.095,0,20.119,9.026,20.119,20.12v7.945C86.425,89.556,84.529,91.451,82.189,91.451z')

      path(d='M50.425,51.738c-11.091,0-20.116-9.024-20.116-20.116c0-11.09,9.022-20.114,20.111-20.116 c11.09,0,20.116,9.021,20.121,20.11C70.541,42.714,61.517,51.738,50.425,51.738z M50.424,19.978 c-6.421,0.001-11.644,5.225-11.644,11.645c0,6.421,5.224,11.645,11.645,11.645c6.422,0,11.646-5.224,11.646-11.645 C62.067,25.2,56.843,19.978,50.424,19.978z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>